import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import { Component, useEffect, type ReactNode } from 'react';
import { PublicLayout } from './layouts/PublicLayout';
import { LandingPage } from './pages/go2-legende/LandingPage';
import { DashboardPage } from './pages/go2-legende/DashboardPage';
import { PravilaPage } from './pages/go2-legende/PravilaPage';
import { FAQPage } from './pages/go2-legende/FAQPage';
import { LoginPage } from './pages/go2-legende/LoginPage';
import { RegisterPage } from './pages/go2-legende/RegisterPage';
import { ForgotPasswordPage } from './pages/go2-legende/ForgotPasswordPage';
import { ProfilePage } from './pages/go2-legende/ProfilePage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

class ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-go2-pink mb-4">Greška</h1>
            <p className="text-gray-600 mb-8">Došlo je do neočekivane greške.</p>
            <a href="/" className="bg-go2-pink text-white px-6 py-3 rounded-full font-bold">Nazad na početnu</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function NotFound() {
  return (
    <PublicLayout>
      <div className="min-h-[60vh] flex items-center justify-center pt-24">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-go2-pink mb-4">404</h1>
          <p className="text-xl text-gray-600 mb-8">Stranica nije pronađena.</p>
          <Link to="/" className="bg-go2-pink text-white px-6 py-3 rounded-full font-bold inline-block">Nazad na početnu</Link>
        </div>
      </div>
    </PublicLayout>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<PublicLayout><LandingPage /></PublicLayout>} />
          <Route path="/prijava" element={<PublicLayout><LoginPage /></PublicLayout>} />
          <Route path="/registracija" element={<PublicLayout><RegisterPage /></PublicLayout>} />
          <Route path="/zaboravljena-lozinka" element={<PublicLayout><ForgotPasswordPage /></PublicLayout>} />
          <Route path="/pravila" element={<PublicLayout><PravilaPage /></PublicLayout>} />
          <Route path="/faq" element={<PublicLayout><FAQPage /></PublicLayout>} />
          <Route path="/go2-legende/dashboard" element={<DashboardPage />} />
          <Route path="/go2-legende/profil" element={<ProfilePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
